export const SelectedActions = {
  EMPTY: () => ({
    type: "SelectedActions.EMPTY",
  }),
  SELECTED: (uri) => ({
    type: "SelectedActions.SELECTED",
    uri
  }),
};
